<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteCountry" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Code:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="country.code" />
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Name:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Name" v-model="country.name" />
									</div>
								</div>
	
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Status:</label>
									</div>
												
									<div class="col-md-6">
										<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="country.isClosed" />
									</div>
								</div>
											
								<div class="row mb-3">
									<div class="col-md-3"></div>
												
									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.country.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
													
										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import countryApi from "@/api/country-api";
	import statusMixin from "@/mixin/status";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	import useVuelidate from "@vuelidate/core"
	import { required } from "@vuelidate/validators"
	
	export default defineComponent({
		mixins: [statusMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				country: {code: '', name: '', isClosed: false},
				isPageLoading: false,
				isLoading: false,
				isDeleting: false,
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				if (this.identifier != null) {
					this.isPageLoading = true;
					countryApi.countryView(this.identifier)
						.then(response => {
							this.country = response.data.country;
							
							this.isPageLoading = false;
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
			}
		},
		methods: {
			save() {
				this.isLoading = true;
				countryApi.countrySave({
						country: this.country
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push("/admin/country");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				countryApi.countryUpdate({
						country: this.country
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push("/admin/country");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			deleteCountry() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this country?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						countryApi.countryDelete({
								country: this.country
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/country");
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push("/admin/country");
			}
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				country : {
					code: {
						required
					},
					name: {
						required
					},
					isClosed: {
						required
					},
				}
			}
		}
	});
</script>
